module.exports = __webpack_public_path__ + "media/images/items/thumbnail-3-73ae844444bd0f73aa5c0aa5c0737c60.jpg";